module.exports = __webpack_public_path__ + "static/logo-wordmark-394b26b9ff83d855a0ab1e3926666871.png";